import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import EyeSlash from "../../Assets/Image/admin/slasheye.png";
import Eye from "../../Assets/Image/admin/eye.png";
import { Circles } from "react-loader-spinner";
import { json, useNavigate } from "react-router-dom";
import welo from "../../Assets/Image/sidebar/e-logo.png";
import toast from "react-hot-toast";
import axios from "axios";
import Cookies from "js-cookie";
import { DELETE_ACCOUNT_API } from "../../Services/Api";

function DeleteAccount() {
  const navigate = useNavigate();
  const [eyes, setEyes] = useState(0);
  const [texts, setTexts] = useState("password");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    document.title = "E-Learning Delete Account";
  }, []);

  const handleEyes = () => {
    const flag = eyes === 0 ? 1 : 0;
    setEyes(flag);

    const text = texts === "password" ? "text" : "password";
    setTexts(text);
  };

  const initialValues = {
    email: "",
    password: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .matches(/^[a-z0-9._%+-]+@gmail\.com$/, "Invalid email address")
      .required("Required"),
    password: Yup.string()
      .min(8, "Minimum 8 characters required")
      .required("Required"),
  });

  const handleSubmit = (values, resetForm) => {
    console.log("value >>", values);

    setIsLoading(true);
    axios
      .delete(DELETE_ACCOUNT_API, {
        headers: {
          "content-type": "application/json",
          accept: "application/json",
        },
        data: {
          email: values.email,
          password: values.password,
        },
      })
      .then((res) => {
        if (res.data.status === 1) {
          toast.success(res.data.message);
          resetForm();
          setIsLoading(false);
        } else {
          toast.success(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Something went wrong");
        setIsLoading(false);
      });
  };

  return (
    <div className="grid grid-cols-12 fontNew">
      <div className="col-span-12 mx-3">
        <div className="text-start flex justify-center items-center h-[100vh]">
          <div className="text-center">
            <div className="flex justify-center mb-10">
              <img src={welo} className="w-[180px] h-[40px]" alt="" />
            </div>
            <h4 className="sm:text-3xl text-xl font-semibold">
              Delete Account?
            </h4>
            <h6 className="md:w-[380px] w-full px-5 break-word py-3">
              Are you sure you want to delete your account on Migrante Xperience
              User App?
            </h6>
            <div className="flex justify-center">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values, { setSubmitting, resetForm }) =>
                  handleSubmit(values, resetForm)
                }
              >
                {({ isSubmitting }) => (
                  <Form className="w-full mx-5">
                    <div>
                      <div className="flex items-center mt-3">
                        <p className="fontNew text-sm font-medium">Email :</p>
                        <ErrorMessage
                          name="email"
                          component="div"
                          className="text-red-500 text-sm ms-2"
                        />
                      </div>
                      <div className="mt-3 mb-6">
                        <div className="md:w-[380px] w-full flex my-3 items-center">
                          <Field
                            type="email"
                            name="email"
                            autoComplete="off"
                            className="bg-transparent px-4 rounded-xl border-2 border-slate-300 w-full outline-[#e1c595] h-[54px] text-base"
                            placeholder="Email"
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="flex items-center mt-2">
                        <p className="text-sm font-medium">Password :</p>
                        <ErrorMessage
                          name="password"
                          component="div"
                          className="text-red-500 text-sm ms-2"
                        />
                      </div>
                      <div className="mt-3 mb-6">
                        <div className="md:w-[380px] w-full flex my-3 items-center">
                          <Field
                            type={texts}
                            name="password"
                            autoComplete="off"
                            className="bg-transparent ps-4 pe-12 rounded-xl border-2 border-slate-300 w-full outline-[#e1c595] h-[54px] text-base"
                            placeholder="Password"
                          />
                          {eyes === 0 ? (
                            <img
                              src={EyeSlash}
                              onClick={handleEyes}
                              className="p-2 w-10 h-10 -ms-12 cursor-pointer"
                              alt=""
                            />
                          ) : (
                            <img
                              src={Eye}
                              onClick={handleEyes}
                              className="p-2 w-10 h-8 -ms-12 cursor-pointer"
                              alt=""
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="mt-14">
                      <button
                        type="submit"
                        className="fontNew h-[54px] items-center md:w-[380px] w-full rounded-2xl flex font-base justify-center text-white text-base bg-[#e29c29]"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <Circles
                            width={23}
                            height={23}
                            color="#fff"
                            ariaLabel="circles-loading"
                            wrapperStyle={{}}
                            visible={true}
                            wrapperClass=""
                          />
                        ) : (
                          "Delete Account"
                        )}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeleteAccount;
